// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface ILastTargetEntity {
	deviceId: string | undefined;

	lastUpdate: string | undefined;

	$type?: string | undefined;
}
export class LastTargetEntity {
	constructor(data?: ILastTargetEntity) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.lastUpdate) { this.lastUpdate = new Date(data.lastUpdate); }
	}

	deviceId: string | undefined;

	lastUpdate: Date | undefined;

	static $type: string = "CoreApi.Entities.LastTargetEntity, ";
	$type?: string | undefined = LastTargetEntity.$type;
}

